import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { for: "file-input" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "button-container" }

import ButtonIcon from "@/components/ButtonIcon.vue";
import { useI18n } from "vue-i18n";
import enUK from "@/locales/en-UK.json";
import { ref, watch } from "vue";
import { uploadFile } from "@/services/file";

type MessageSchema = typeof enUK;


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageUploader',
  props: {
    currentUrl: {}
  },
  emits: ["changed", "cleared"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { t } = useI18n<[MessageSchema], "en-UK">({
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const file = ref();
const fileName = ref();
const preview = ref<string | ArrayBuffer | null | undefined>(props.currentUrl);
const hasUploadedImage = ref(false);

watch(
  () => props.currentUrl,
  () => {
    hasUploadedImage.value = false;
  },
);

const handleFileChange = (input: HTMLInputElement | DataTransfer | null) => {
  if (!input?.files) {
    file.value = undefined;
    fileName.value = undefined;
    preview.value = undefined;
    return;
  }
  file.value = input.files[0];
  fileName.value = file.value.name;

  const reader = new FileReader();
  reader.readAsDataURL(file.value);

  reader.onload = (e) => {
    preview.value = e.target?.result;
    hasUploadedImage.value = true;
  };
};

const uploadImage = async () => {
  if (!file.value) {
    return;
  }
  const [fileId] = await uploadFile([file.value]);
  emits("changed", fileId);
};

const clearImage = async () => {
  file.value = undefined;
  fileName.value = undefined;
  preview.value = undefined;
  hasUploadedImage.value = false;

  if (props.currentUrl) {
    emits("cleared");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "dropzone",
      onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDragstart: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleFileChange($event.dataTransfer)), ["prevent"]))
    }, [
      _createElementVNode("input", {
        id: "file-input",
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFileChange($event.target as HTMLInputElement))),
        required: ""
      }, null, 32),
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)("imageUploader.label")), 1),
      (preview.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: preview.value,
            class: "preview-image"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ], 32),
    _createElementVNode("div", _hoisted_3, [
      (hasUploadedImage.value)
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 0,
            label: _unref(t)('buttons.upload'),
            "icon-name": "jam:upload",
            onClick: uploadImage
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (__props.currentUrl || hasUploadedImage.value)
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 1,
            label: _unref(t)('buttons.clear'),
            "icon-name": "material-symbols:close",
            onClick: clearImage
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})